export default {
  // 线上环境
  // 获得配置客服器配置
  apiBaseUrl: 'https://hn-kaixin-php.ppgame777.com',
  // 客服服务器地址
  socketUrl: 'wss://hn-kaixin-php.ppgame777.com/ws',
  // 上传图片和获得地址
  uploadImageUrl: 'https://in-teenpatti-worker.ga11.win/api/file/upload'
}
